import React, { Component } from "react";
import { Box, Image, Center, Text } from "@chakra-ui/react";
import logo from "./AOK_Logo_b.png"

export default class HomePage extends Component {

    render() {
        return (
            <div><Center><Box
                m="8px"
                p="8px"
                border="1px"
                rounded="10px"
                borderColor="gray.300"
                boxShadow="md"
                bg="white"
                color="#2d383c"
                fontSize="2rem"
                textAlign="center"
                fontFamily="Consolas"
                w="100%"
            >
                <Center>
                    <Image src={logo} rounded="0.5rem" />
                </Center>
                <Text m={"30px"} p={"30px"}>Data Portal Pre-Release</Text>

            </Box></Center>
            </div>
        );
    }
}
